import RowItemWidget from './rowItemWidget'
import { ACTION_FETCH_DSR_SUMMARY, DsrSummary, fetchDsrSummary } from '../privacyOpsOverviewSlice'
import { getCreatedDateUrlFilter } from '../../dsr/utils'
import { RootState } from '../../../rootReducer'
import { getShowLoader } from '../../../reducers/requestReducer'
import {
  DSR_FILTER_MANUAL_ACTION,
  DSR_TICKET_STATUS_FILTER_TYPES,
  FILTER_CREATED_AT,
  FILTER_DUE_DATE,
  FILTER_NEED_MANUAL_ACTION,
  FILTER_STATUS_KEY,
  URL_DSR,
  URL_DSR_REQUEST_MANAGEMENT,
  URL_TICKETS
} from '../../../constants'
import { getUpdatedUrl } from '../../../utils/urlUtil'
import { useIntl } from 'react-intl'
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'

interface IProps {
  showLoader: boolean
  dsrSummary: DsrSummary
  timePeriod?: string
  fetchDsrSummary: (timePeriod: string) => void
}

const DSRSummaryWidget = ({ dsrSummary, timePeriod = '', showLoader, fetchDsrSummary }: IProps) => {
  const intl = useIntl()

  const createdDateUrlFilter = useMemo(() => getCreatedDateUrlFilter(timePeriod), [timePeriod])

  useEffect(() => {
    fetchDsrSummary(timePeriod)
  }, [fetchDsrSummary, timePeriod])

  const widgetData = useMemo(
    () =>
      Object.keys(dsrSummary).length
        ? [
            {
              key: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.line1' }),
              value: `${dsrSummary.openRequests} / ${dsrSummary.totalRequests}`,
              link: getUpdatedUrl({
                pathName: `${URL_DSR}${URL_DSR_REQUEST_MANAGEMENT}`,
                pageName: URL_DSR_REQUEST_MANAGEMENT,
                pageQueryParams: {
                  [FILTER_CREATED_AT]: createdDateUrlFilter
                }
              })
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.line5' }),
              value: `${dsrSummary.openTickets} / ${dsrSummary.totalTickets}`,
              link: getUpdatedUrl({
                pathName: `${URL_DSR}${URL_TICKETS}`,
                pageName: URL_TICKETS,
                pageQueryParams: {
                  [FILTER_STATUS_KEY]: DSR_TICKET_STATUS_FILTER_TYPES.open
                }
              })
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.line2' }),
              value: dsrSummary.requestsNeedAttention,
              link: getUpdatedUrl({
                pathName: `${URL_DSR}${URL_DSR_REQUEST_MANAGEMENT}`,
                pageName: URL_DSR_REQUEST_MANAGEMENT,
                pageQueryParams: {
                  [FILTER_NEED_MANUAL_ACTION]: DSR_FILTER_MANUAL_ACTION.NEEDED,
                  [FILTER_CREATED_AT]: createdDateUrlFilter
                }
              })
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.line3' }),
              value: dsrSummary.automationFailures
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.line4' }),
              value: dsrSummary.requestsPastDue,
              link: getUpdatedUrl({
                pathName: `${URL_DSR}${URL_DSR_REQUEST_MANAGEMENT}`,
                pageName: URL_DSR_REQUEST_MANAGEMENT,
                pageQueryParams: {
                  [FILTER_DUE_DATE]: 'pastDue',
                  [FILTER_CREATED_AT]: createdDateUrlFilter
                }
              })
            }
          ]
        : [],
    [dsrSummary]
  )

  return (
    <RowItemWidget
      widgetData={widgetData}
      title={intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.title' })}
      showLoader={showLoader}
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  dsrSummary: state.privacyOpsOverview.dsrSummary,
  timePeriod: state.customDashboards.filterProps?.timePeriod,
  showLoader: getShowLoader(ACTION_FETCH_DSR_SUMMARY)
})
const mapDispatchToProps = { fetchDsrSummary }

export default connect(mapStateToProps, mapDispatchToProps)(DSRSummaryWidget)
